export default {
  router: [
    {
      exact: true,
      path: '/fqs/certificate/matchingQualificationUpload',
      title: '匹配资质上传',
    },
  ],
  title: '匹配资质上传',
};
